import { types, getSnapshot } from "mobx-state-tree";
import { TableColumn } from "../../tables/ScanbuyTable";
import { GroupSelectState } from "../../elements/groups/GroupSelectState";
import { BatchList } from "../../../models/batch/BatchList";
import BatchFormState from "../../codes/batches/BatchFormState";
import { BatchFilterSelectState } from "../../elements/filters/BatchFilterSelectState";
import lodash from "lodash";
import Group from "../../../models/Group";
import {ModalState} from "../../elements/modal/GenericModal";

const BatchListState = types.model('BatchListState',{
    store: types.maybe(types.reference(BatchList)), // <-- hold the store
    columns: types.array(types.late(() => TableColumn)),
    groupSelectStore: types.maybe(types.reference(GroupSelectState)),
    batchFormState: types.maybe(types.late(() => types.reference(BatchFormState))),
    selectedGroup: types.maybe(types.reference(Group)),
    batchFilterSelectState: types.maybeNull(types.reference(BatchFilterSelectState)),
    modalStore: types.maybe(types.reference(ModalState)),
    optionalColumns: types.optional(types.array(types.string), []),
    columnNameMapping: types.optional(types.map(types.string), {}),
    tableOptionalColumns: types.optional(types.array(types.string), [])
}).volatile((self) => ({
    modalComponent: types.object,
    modalComponentStore: types.object,
    modalSize: types.str,
    modalClassName: types.str,
}))
  .actions((self) => ({
    refresh(){
      self.store.fetchAll()
    },
    setColumns(col) {
      self.columns = col
    },
    setOnSelectChanges() {
      self.groupSelectStore.setConsumer(self.selectGroup)
      self.batchFilterSelectState?.setConsumer(self.selectFilter)
    },
    selectFilter(obj, covered){
      self.store.removeSearchParams(covered);
      if(obj){
        const params = lodash.mapValues(obj,(value, key) => {
          return {}[key] = value.join(',');
        });
        self.store.addSearchParams(params)
        self.refresh()
      }
    },
    addRow(data) {
      //? P / ...
    },
    deleteRow(row) {

    },
    afterCreate() {

    },
    selectGroup(obj) {
      self.selectedGroup = obj;
      self.store.addSearchParams({groupUuid: obj?.uuid})
      // self.refresh()
    },
    handleFilterChange(e) {
      console.log("BatchListState handleFilterChange")
      // self.store.fetchAll(e);
    },
    setColumnNameMapping(mapping) {
      self.columnNameMapping = mapping;
    },
    setTableOptionalColumns(columns) {
      self.tableOptionalColumns = columns;
    },
    toggleColumnVisibility(columnId) {
      if (self.optionalColumns.includes(columnId)) {
        self.optionalColumns.replace(self.optionalColumns.filter(id => id !== columnId));
      } else {
        self.optionalColumns.push(columnId);
      }
      self.saveColumnsToSession();
    },
    saveColumnsToSession() {
      try {
        const columns = getSnapshot(self.optionalColumns);
        sessionStorage.setItem("batchListColumns", JSON.stringify(columns));
      } catch (e) {
        console.warn("Failed to save column visibility to sessionStorage", e);
      }
    },
    loadColumnsFromSession() {
      try {
        const saved = sessionStorage.getItem("batchListColumns");
        if (saved) {
          self.optionalColumns.replace(JSON.parse(saved));
        }
      } catch (e) {
        console.warn("Failed to load column settings from sessionStorage", e);
      }
    }
  }))


export default BatchListState
